import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [createPersistedState()],

    state: {
        tokens: null,
        usuarioAtual: null,
        logado: false
    },

    actions: {
        login(context, usuario) {
            return new Promise((resolve, reject) => {
                let dados = {
                    ba01_usuario: usuario.acesso,
                    ba01_senha: usuario.senha,
                    ba01_lembrar_token : (usuario.lembrar) ? '1' : '0'
                };

                axios.post(API.login, dados, {
                    withCredentials: true,
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    }
                }).then(resp => {
                    let respDado = resp.data;
                    let agora = Date.now();

                    respDado.expira_em = respDado.expira_em + agora;
                    context.commit('atualizaToken', respDado);
                    axios.defaults.headers.common['Authorization'] = `Bearer ${respDado.access_token}`;
                    resolve(resp)
                }).catch(function (erro) {
                    resolve(erro)
                });
            })
        },

        configurarUsuario(context, usuario) {
            return new Promise((resolve, reject) => {
                context.commit('atualizaUsuario', usuario);
                resolve();
            });
        },

        atualizaToken(context){
            return new Promise((resolve, reject) => {
                    API.enviarRequisicao('post', API.refreshToken, {}, {
                        withCredentials: true
                    }).then(resp => {
                        if(resp.data.access_token){
                            let respDado = resp.data;
                            let agora = Date.now();

                            respDado.expira_em = respDado.expira_em + agora;
                            context.commit('atualizaToken', respDado);

                            axios.defaults.headers.common['Authorization'] = `Bearer ${respDado.access_token}`;

                            resolve(resp)
                        }else if(resp.data.erro) {
                            console.log(resp.data.erro);
                            context.commit('desloga');
                            resolve({erro: true})
                        }
                    }).catch(function (erro) {
                        console.log('Erro: '+erro);
                        context.commit('desloga');
                        resolve({erro: true})
                    });
            });
        },

        deslogar(context){
            context.commit('desloga');
        },

        atualizarUsuario(context, usuario){
            return new Promise((resolve, reject) => {
                context.commit('atualizaUsuario', usuario);
                resolve();
            });
        }
    },

    mutations: {
        atualizaToken(estado, dados) {
            estado.tokens = {
                access_token:  dados.access_token,
                expira_em : dados.expira_em,
                token_type: 'Bearer'
            };
        },

        atualizaUsuario(estado, usuarioAtual) {
            estado.usuarioAtual = usuarioAtual;
            estado.logado = true;
        },

        desloga(estado){
            estado.tokens = null;
            estado.usuarioAtual = null;
            estado.logado = false;
        }
    },

    getters: {
        pegaAccessToken(estado){
            if(estado.tokens != null){
                return estado.tokens.access_token
            }else{
                return null;
            }
        },
        pegaTempoExp(estado){
            if(estado.tokens != null){
                return estado.tokens.expira_em
            }else{
                return null;
            }
        },
        pegaUsuarioAtual(estado) {
            return estado.usuarioAtual
        },
    },

});
